import React, { useEffect, useState, useRef } from 'react'; 
import QuantitySelector from '../QuantitySelector';
import FeatureList from '../FeatureList';
import { translate } from '../../Services/translation';
import { culture } from '../../Services/culture';
import formatCurrencyService from '../../Services/formatCurrencyService';
import { currency } from '../../Services/currency';
import { useSelector } from 'react-redux';
import { CURRENCY_GERMANY } from '../../constants';

const BuyBox = ({ buy, quantity, articleNumber, updateQuantity, comment, stockInfoMessage, totalPrice, currentPrice, stockstatus, originalPrice, formatter, enabled,
    toggleOptions, packagingQuantity,
    productInfoMessage, featureList, isSuperBuilderActive, scroll, lowestPrice30Days, campaignRemainingDays, campaignRemainingDaysDesc, variantSystemId }) => {

    const superBuilder = useSelector((state) => state.superBuilder);
    const superBuilderValid = superBuilder.mandatorySectionsValid;
    const [lowestPriceVisible, setlowestPriceVisible] = useState(false);
    const [showQuantitySelector, setShowQuantitySelector] = useState(false);
    const [currentquantity, setCurrentquantity] = useState(quantity);
    const cart = useSelector((state) => state.cart);
    const wrapperRef = useRef(null);
    const [isSticky, setIsSticky] = useState(false);

    const buyButtonClicked = () => {
        setShowQuantitySelector(true);
        buy();
    }

    useEffect(() => {
        quantitySelectorInfo();
    }, [cart]);

    useEffect(() => {
        quantitySelectorInfo();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (!wrapperRef.current) return;
            const rect = wrapperRef.current.getBoundingClientRect();
            const windowHeight = window.innerHeight;
            const shouldBeSticky = rect.bottom > windowHeight + 2;
            setIsSticky(shouldBeSticky);
        };

        const initTimeout = requestAnimationFrame(() => {
            handleScroll();
        });

        window.addEventListener('scroll', handleScroll, { passive: true });
        window.addEventListener('resize', handleScroll);

        return () => {
            cancelAnimationFrame(initTimeout);
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    const quantitySelectorInfo = () => {
        if (cart && cart.orderRows.length > 0) {
            const currentArticleRow = cart.orderRows.find(x => x.articleNumber === articleNumber);
            if (currentArticleRow === null || currentArticleRow === undefined) {
                const rowMatching = cart.orderRows.find((row) => row.comments && JSON.parse(row.comments).parentVariantId === variantSystemId);

                if (rowMatching) {
                    setShowQuantitySelector(true);
                    articleNumber = rowMatching.articleNumber;
                    setCurrentquantity(rowMatching.quantity);
                } else {
                    setShowQuantitySelector(false);
                }
            } else {
                setShowQuantitySelector(true);
                setCurrentquantity(currentArticleRow.quantity);
            }
        } else {
            setShowQuantitySelector(false);
        }
    }

    const buyBoxClasses = [
        'buy-box',
        isSuperBuilderActive ? 'buy-box--superbuilder' : '',
        isSticky ? 'buy-box--sticky' : ''
    ].filter(Boolean).join(' ');

    return (
        <div ref={wrapperRef} className={'buy-box-wrapper' + (campaignRemainingDays ? ' add-height' : '')}>
            <div className={buyBoxClasses}>
                <div className={'buy-box__main' + (stockstatus.onlyInStore ? ' buy-box__main-store' : '')}>
                    {campaignRemainingDays &&
                        <div className="campaign-banner"
                            tabIndex={0}
                            role="button"
                            aria-label="Visa kampanjbeskrivning"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                }
                            }}
                        >
                            <span className="campaign-banner__title">{campaignRemainingDays}</span>
                            <div className="description" dangerouslySetInnerHTML={{ __html: campaignRemainingDaysDesc }}></div>
                        </div>
                    }
                    <div className="price-box">
                        <div itemProp="offers" itemScope itemType="https://schema.org/Offer" className={originalPrice != totalPrice ? 'price-box__campaign' : 'price-box__default'}>
                            {articleNumber === 'n/a' && <span>{translate('product-item.configurator.priceprefix')}</span>}
                            {lowestPrice30Days !== "" ? <div className='lowestprice__container'>
                                {lowestPriceVisible && <div className='lowestprice-info-message'>{lowestPrice30Days}</div>}
                                <span itemProp={originalPrice != totalPrice ? "sale_price" : "price"} content={totalPrice}
                                    className="price-box__current-price">{formatCurrencyService.formatCurrency(formatter, totalPrice)}</span>
                                {lowestPrice30Days !== "" && <span className='lowestprice-info-message--icon' onClick={() => setlowestPriceVisible(!lowestPriceVisible)}></span>}
                            </div> :
                                <span itemProp={originalPrice != totalPrice ? "sale_price" : "price"} content={totalPrice}
                                    className="price-box__current-price">{formatCurrencyService.formatCurrency(formatter, totalPrice)}</span>}
                            {originalPrice != totalPrice &&
                                <span itemProp="price" content={originalPrice}
                                    className="price-box__original-price">{formatCurrencyService.formatCurrency(formatter, originalPrice)}
                                </span>
                            }
                            {productInfoMessage && (
                                <div className="product-info-message">
                                    {productInfoMessage}
                                </div>
                            )}
                            <meta itemProp="priceCurrency" content={currency}></meta>
                        </div>
                    </div>
                    {currency === CURRENCY_GERMANY && <div>
                        {totalPrice >= 500 ? 
                        <p className='german-info-message'>{translate("product.german.pricewithshipping.text")}</p> : 
                        <p className='german-info-message'>{translate("product.german.pricewithoutshipping.text")}</p>}
                    </div>}
                    {!stockstatus.onlyInStore && <div className="buy-box__inner">
                        <div className="buy-box__controls">
                            <div className="buy-box__quantity-container">
                                {showQuantitySelector && <div className="buy-box__quantity-large">
                                    <QuantitySelector isSmall={false} quantity={currentquantity} articleNumber={articleNumber} packagingQuantity={packagingQuantity}
                                        onChange={updateQuantity}></QuantitySelector>
                                </div>}
                            </div>
                            {!showQuantitySelector && isSuperBuilderActive && !superBuilderValid && !enabled && (
                                <button role="button" className={'buy-box__buy'} onClick={() => { scroll() }}>{translate('configurator.superbuilder.button.configure')}</button>
                            )}
                            {!showQuantitySelector && isSuperBuilderActive && enabled && superBuilderValid && (
                                <button role="button" className={'buy-box__buy' + (enabled ? '' : ' buy-box__buy--disabled')}
                                    onClick={() => { buyButtonClicked() }}>{translate('cart.add')}</button>
                            )}
                            {!showQuantitySelector && isSuperBuilderActive && !enabled && superBuilderValid && (
                                <button role="button" className={'buy-box__buy'} onClick={() => { toggleOptions() }}>{translate('configurator.button.configure')}</button>
                            )}
                            {!showQuantitySelector && !isSuperBuilderActive && enabled && (
                                <button role="button" className={'buy-box__buy' + (enabled && !stockstatus.discontinued ? '' : ' buy-box__buy--disabled')}
                                    onClick={() => { buyButtonClicked() }}>{translate('cart.add')}</button>
                            )}
                            {!showQuantitySelector && !isSuperBuilderActive && !enabled && (
                                <button role="button" className={'buy-box__buy' + (!stockstatus.discontinued ? '' : ' buy-box__buy--disabled')}
                                    onClick={() => { toggleOptions() }}>{translate('configurator.button.configure')}</button>
                            )}
                        </div>
                        {stockstatus.onlyInStore && <div className="buy-box__inner">
                            <div className="buy-box__controls-store">
                                <div className="buy-box__quantity-container">
                                    {productInfoMessage && (
                                        <div className="product-info-message">
                                            {productInfoMessage}
                                        </div>
                                    )}
                                </div>
                                <button role="button" className="buy-box__buy buy-box__buy--disabled">{translate('stockstatus.store')}</button>
                            </div>
                        </div>}
                    </div>}
                    {!stockstatus.onlyInStore && <div className={'price-box-partpayment' + (productInfoMessage ? ' has-bundle-message' : '')}>
                        <div>
                            <klarna-placement data-key="top-strip-promotion-auto-size"
                                data-locale={culture}></klarna-placement>
                        </div>
                    </div>}
                    {!stockstatus.onlyInStore && <FeatureList featureList={featureList.filter(x => x.showUnderBuyButton)}></FeatureList>}
                </div>
            </div>
        </div>
    )
}

export default BuyBox;